import { 
  Accordion, 
  AccordionItem, 
  AccordionButton, 
  AccordionPanel, 
  AccordionIcon, 
  Box, 
  VStack, 
  Text, 
  Icon, 
  Button, 
  Flex, 
  Input
} from "@chakra-ui/react";
import { FaBook, FaClipboardCheck, FaVideo } from "react-icons/fa";

export const Outline = ({data, onOutlineChange, onModuleTitleChange, editMode, setEditMode}) => {

  return (
    <>
      <Flex justifyContent="flex-end" mb={2}>
        <Button onClick={() => setEditMode(!editMode)} variant="outline" colorScheme="blue">Edit</Button>
      </Flex>
      <Accordion defaultIndex={[0]} allowMultiple width="100%" border="1px solid #E2E8F0" borderRadius="md" overflow="hidden">
        {data?.modules?.map((module, index) => (
          <AccordionItem key={index} borderBottom="1px solid #E2E8F0">
            <h2>
              <AccordionButton _expanded={{ bg: "gray.100" }}>
                <Box flex="1" textAlign="left" fontWeight="bold">
                  {
                    editMode ? <Input value={module.moduleTitle} onChange={(e) => onModuleTitleChange(e, index)}/> : <>{module.moduleTitle}</>
                  }
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel pb={4}>
              <VStack align="start" spacing={2}>
                {
                  module?.content?.readingEdDocs?.length > 0 ?
                    <Box>
                      <Text fontWeight="semibold" display="flex" alignItems="center">
                        <Icon as={FaBook} color="blue.500" mr={2} /> Readings
                      </Text>
                      {module.content?.readingEdDocs?.map((reading, i) => (
                        editMode ? <Input value={reading.title} onChange={(e) => onOutlineChange(e, "readingEdDocs", i, index)} mb={2}/> : <Text key={i} pl={6}>- {reading.title}</Text>
                      ))}
                    </Box> : <></>
                }
                {
                  module?.content?.assessmentEdDocs?.length > 0 ?
                    <Box>
                      <Text fontWeight="semibold" display="flex" alignItems="center">
                        <Icon as={FaClipboardCheck} color="green.500" mr={2} /> Assessments
                      </Text>
                      {module.content?.assessmentEdDocs?.map((assessment, i) => (
                        editMode ? <Input value={assessment.title} onChange={(e) => onOutlineChange(e, "assessmentEdDocs", i, index)}/> : <Text key={i} pl={6}>- {assessment.title}</Text>
                      ))}
                    </Box> : <></>
                }
                {
                  module?.content?.videos?.length > 0 ?
                    <Box>
                      <Text fontWeight="semibold" display="flex" alignItems="center">
                        <Icon as={FaVideo} color="red.500" mr={2} /> Videos
                      </Text>
                      {module.content?.videos?.map((video, i) => (
                        editMode ? <Input value={video.title} onChange={(e) => onOutlineChange(e, "videosEdDocs", i, index)}/> : <Text key={i} pl={6}>- {video.title}</Text>
                      ))}
                    </Box> : <></>
                }
              </VStack>
            </AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </>
  );
};

